import React, {FC, memo} from "react";
import {Tooltip} from "antd";
import {MollieSvg} from "../../assets/SVG-Icons";

type MollieBadgeProps = {
    /** Tooltip-Text. Default passt zur Buchungs-Semantik. */
    title?: string;
    /** Größen-/Stil-Override (MollieSvg ist em-basiert → fontSize steuert die Breite). */
    style?: React.CSSProperties;
};

const MollieBadge: FC<MollieBadgeProps> = ({title = "Mollie-Zahlung", style}) => (
    <Tooltip title={title}>
        <span
            style={{
                marginLeft: 4,
                color: "#000",
                display: "inline-flex",
                alignItems: "center",
                verticalAlign: "middle",
                paddingBottom: 3,
                ...style,
            }}
        >
            <MollieSvg />
        </span>
    </Tooltip>
);

export default memo(MollieBadge);
